import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class CsvService {

	// this function can be included in convert to CSV function
	getHeadersToCSV(allowedHeaders: Record<string, string>[]): string {
		let headerString = "";
		allowedHeaders.forEach((header) => {
			const headerkey = Object.keys(header)[0];
			// for header value for only the first loop
			if (headerString !== "") headerString += ",";
			headerString += header[headerkey];
		});
		return headerString;
	}

	convertToCSV(objArray: Record<string, any>[], allowedHeaders: Record<string, string>[]): string {
		let str = "";
		const headerString = this.getHeadersToCSV(allowedHeaders);
	  
		for (const record of objArray) {
		  let line = "";
		  allowedHeaders.forEach((header) => {
			const headerKey = Object.keys(header)[0];
			let field: any = record[headerKey] ?? "";
			
			// Convert field to string if it's not already a string
			if (typeof field !== "string") {
			  field = String(field);
			}
	  
			// If the field contains commas, newlines, or quotes, wrap it in quotes.
			if (field.indexOf(',') >= 0 || field.indexOf('\r') >= 0 || field.indexOf('\n') >= 0 || field.indexOf('"') >= 0) {
			  // Escape any existing quotes by doubling them
			  field = '"' + field.replace(/"/g, '""') + '"';
			}
			
			if (line !== "") line += ",";
			line += field;
		  });
		  str += line + "\r\n";
		}
	  
		return headerString + "\r\n" + str;
	  }
	  
	  

	exportCSVFile(fileTitle: string, headers: Record<string, string>[], items: any[]): void {
		const csv = this.convertToCSV(items, headers);
		const exportedFilename = fileTitle.trim() ? fileTitle.trim() + ".csv" : "export.csv";
		const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });

		const link = document.createElement("a");
		if (link.download !== undefined) {
			// feature detection
			// Browsers that support HTML5 download attribute
			const url = URL.createObjectURL(blob);
			link.setAttribute("href", url);
			link.setAttribute("download", exportedFilename);
			link.style.visibility = "hidden";
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		}
	}
}
